import { Model } from 'json-api-models';

import type { Models, Schemas } from '../models.ts';

export class ModuleProgress extends Model<Schemas['moduleProgress'], Models> {
    get isComplete(): boolean {
        return this.progress === 1;
    }

    /** The ID of the module's only content, when that is a collection. */
    get soleCollectionId(): string | undefined {
        return this.relationships.soleCollection?.data?.id;
    }
}
